module.exports = __webpack_public_path__ + "img/zhihuixuexiao.9068cd3c.png";